import { gql } from '@apollo/client';

export const ALL_SP_ECD_SERVICES = gql`
  query AllServiceProviderECDServices($input: FilterInstitutions!) {
    institutions: filteredSPECDServices(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          district {
            id
            name
          }
          ecdRegistrationProgress
          latestUnsubmittedECDRegistration {
            id
            approvalStatus
            modifiedBy {
              id
            }
          }
          localMunicipality {
            id
            localMunicipality
            localMunicipalityShorthand
          }
          name
          registrationOffice {
            id
            isInstitution
            isServiceProvider
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          streetAddress
          streetNo
          type {
            id
            name
          }
          verified
          validated
          wardID
          wardLabel
          duplicateReference
          duplicateAction
        }
      }
    }
  }
`;
